
<form name="form" (keydown)="onKeyDown($event, f.form.valid)" #f="ngForm" novalidate *ngIf="this.firstStep
&& !this.passwordExpiry
&& (!controlPasswordExpired || !this.LoggedInUserListCheck ||
(!controlPasswordExpired && !this.LoggedInUserListCheck))" style="height: 100%; margin-top: -15%; position: relative">

  <div class="card card-login" style="background-color: white; height: 50%; border-radius: 0px">
    <div class="card-content">

      <!--logo section -->
      <div class="row">
        <div class="container-fluid">
          <div class="login-header text-center">
            <img [src]="this.logoPath" class="logo" alt="able+" title="able+" />
            <h3 class="title hidden">able+</h3>
          </div>
        </div>
      </div>
      <!--logo section end-->

      <!--First step-->
      <div class="row" *ngIf="!this.nextStep">
        <div class="input-group col-md-11 col-lg-11 col-sm-11 col-xs-11">
          <span class="input-group-addon">
            <i class="material-icons">account_box</i>
          </span>
          <div class="form-group label-floating is-empty" [ngClass]="{'has-error': f.submitted && !username.valid, 'is-empty': username=='' }">
            <label class="control-label">Username</label>
            <input type="text" class="form-control" name="username" [(ngModel)]="model.username" #username="ngModel"
                   required />
          </div>
        </div>
      </div>

      <div class="text-center margin-top-base padding-top-base" *ngIf="!this.nextStep">
        <a class="btn btn-primary btn-block" [ngStyle]="{'background-color': this.sharedService.ButtonColor.value, 'color':  this.sharedService.TextButtonColor.value}"
           (click)="usernameValidation()" (keydown.enter)="usernameValidation()">Next</a>
      </div>
      <!--first step end-->

      <!--Second step-->
      <div class="row" *ngIf="this.nextStep">
        <hr>
        <div class="input-group col-md-11 col-lg-11 col-sm-11 col-xs-11">
          <span class="input-group-addon">
            <a>
              <img style="float: left; height: 35px; width: 35px; text-align: center;vertical-align: middle; margin: 10px 0 0 0; border-radius: 50%; overflow: hidden;"
                   [src]="this.avatar">
            </a>
          </span>
          <div class="form-group label-floating is-empty">
            <span style="color:#3c4043; text-align:center; font-size:14px; font-weight:500; letter-spacing: .25px;font-family: Arial, Helvetica, sans-serif">
              <b>{{this.userNameValidated}}</b>
            </span>
            <a style="cursor:pointer;color:#3c4043" class="pull-right" (click)="onRemoveAccount()" title="Remove account">
              <i class="material-icons">clear</i></a>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="!isLiberateUser && this.nextStep">
        <div class="input-group col-md-11 col-lg-11 col-sm-11 col-xs-11">
          <span class="input-group-addon">
            <i class="material-icons">lock</i>
          </span>
          <div class="form-group label-floating" [ngClass]="{'has-error': f.submitted && !password.valid, 'is-empty': password.toString() === '' }">
            <label class="control-label">Password</label>
            <input [type]="type" class="form-control" name="password" [(ngModel)]="model.password" #password="ngModel"
                   required />
            <span *ngIf="passwordMode" title="Show password" class="input-group-addon addon-right text-gray cursor-pointer"
                  (click)="passwordModeOff();">
            <i class="mdi mdi-eye"></i>
            </span>
            <span *ngIf="!passwordMode" title="Hide password" class="input-group-addon addon-right text-gray cursor-pointer"
                  (click)="passwordModeOn();">
              <i class="mdi mdi-eye-off"></i>
            </span>
          </div>
        </div>
      </div>

      <div class="text-center margin-top-base padding-top-base" *ngIf="!isLiberateUser && this.nextStep">
        <button type="button" (click)="f.form.valid && login()" (keydown.enter)="f.form.valid && login()" [disabled]="loading" class="btn btn-primary  btn-block" [ngStyle]="{'background-color': this.sharedService.ButtonColor.value, 'color':  this.sharedService.TextButtonColor.value}">Login</button>
      </div>
      <!--second step end-->
    </div>


    <!--Liberate user-->
    <div class="row" *ngIf="isLiberateUser">
      <div class="container-fluid">
        <div class="loading-spinner-brand-blue-40">
        </div>
        <div class="card text-center bg-brand-blue text-white">
          <div class="card-content">You are being redirected to the UK Access Federation for authentication to allow
            you to access their resources.</div>
        </div>
      </div>
    </div>
    <!--Liberate user end-->

    <!--forgot password option-->
    <div class="footer text-center">
      <div class="small">
        <a *ngIf= "this.firstStep && !this.nextStep" routerLink="/forgot-username" routerLinkActive="active">Forgot username?</a>
        <a *ngIf= "this.nextStep" routerLink="/forgot-password" routerLinkActive="active">Forgot password?</a>
      </div>
    </div>
    <!--forgot password option end-->
  </div>

  <div *ngIf="facebookEnabled || googleEnabled || linkedinEnabled" id="circle" style="margin-top: -7%; background-color: white; border-radius: 50%; height: 40px; width: 40px; position: absolute; left: 50%; transform: translate(-50%, -50%); display: table; text-align: center; line-height: 40px;" > <!-- [style.top]="!isLiberateUser && this.nextStep === true ? '66%' : '61%'"-->
    or</div>

  <div id="rightSide" style="background-color: #d6d6d6; margin-top: -7%; border-radius: 0px" *ngIf="facebookEnabled || googleEnabled || linkedinEnabled">
    <div class="col">
      <div class="input-group col-md-8 col-lg-8 col-sm-8 col-xs-8" style="margin-left: 18%; height: auto">
        <div class="col" style="margin-top: 50px">
          <button *ngIf="facebookEnabled" (keydown.enter)="$event.preventDefault()" (click)="onLoginWithSocialClick(SocialProviderNameEnum.Facebook)" class="fb btn" style="text-align: left; background-color: #3B5998; color: white; display: block; margin-bottom: 30px; width: 100%">
            <i class="fa fa-facebook fa-fw" style="float:right"></i>Facebook
          </button>
          <button *ngIf="googleEnabled" (keydown.enter)="$event.preventDefault()" (click)="onLoginWithSocialClick(SocialProviderNameEnum.Google)" class="google btn" style="text-align: left;background-color: #dd4b39;color: white; display: block; margin-bottom: 30px; width: 100%"><i class="fa fa-google fa-fw" style="float:right">
          </i>Google
          </button>
          <button *ngIf="linkedinEnabled" (keydown.enter)="$event.preventDefault()" (click)="onLoginWithSocialClick(SocialProviderNameEnum.LinkedIn)" class="linkedin btn" style="text-align: left; background-color: rgb(40,103,178);color: white; display: block; margin-bottom: 30px; width: 100%"><i class="fa fa-linkedin fa-fw" style="float:right">
          </i>LinkedIn
          </button>
        </div>
      </div>
    </div>
  </div>
  <!----card end------>
</form>

<!--modal password expiry-->
<div class="card card-login" *ngIf="passwordExpiry">
  <div class="card-content">
    <password-expiry
      *ngIf="peopleData!=undefined"
      [userLogged]="peopleData"
      [passwordExpirySettings]="{
        hasExpired,
        checkFirstLogin,
        passwordExpiry,
        passwordDaysExpire
      }"
      (skip)="onSkip()"
      (reset)="onReset()"
    >
    </password-expiry>
  </div>
</div>
<!--password expiry end-->

<!--last users accessed-->
<div class="card card-login" *ngIf="this.LoggedInUserListCheck && !this.firstStep">
  <div class="card-content">
    <div class="row">
      <div class="container-fluid">
        <div class="login-header text-center">
          <img [src]="this.logoPath" class="logo" alt="able+" title="able+" />
          <h3 class="title hidden">able+</h3>
        </div>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="container-fluid">
        <p class="text-center">Click on your username to login</p>
        <ul class="list-group selectable padding-top-base">
          <li class="list-group-item avatar login-list-item" *ngFor="let user of this.LoggedInUserList">
            <div (click)="onUserFromList(user.username)" class="cursor-pointer">
              <img [src]="user.avatar" class="circle">
              <strong>{{user.username}}</strong>
            </div>
            <div class="secondary-content">
              <a (click)="onRemoveAccountFromList(user.username)" class="cursor-pointer" title="Remove account">
                <i class="material-icons">clear</i></a>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="footer text-center">
      <div class="small">
        <a style="cursor:pointer" (click)="authenticateAsNewUser()">
          <span class="input-group-addon text-center">
            <i class="material-icons"> account_circle</i> Use another account
          </span>
        </a>
      </div>
    </div>
    <hr>
  </div>
</div>
<!--last users accessed end-->
